import { getQueryParam } from "@circle-react/helpers/urlHelpers";
import { useEffect } from "react";

import { usePaywallCheckoutAttemptsContext } from "./PaywallCheckoutAttemptsContext";

export const PaywallCheckoutAttemptsStageHandler = () => {
  const { verifyAttempt } = usePaywallCheckoutAttemptsContext();

  const invoiceId = getQueryParam("invoice");
  const paymentIntentId = getQueryParam("payment_intent");
  const paymentMethodType = getQueryParam("payment_method_type");
  const setupIntentId =
    !invoiceId && !paymentIntentId
      ? getQueryParam("setup_intent") || getQueryParam("setup_intent_id")
      : undefined;

  useEffect(() => {
    if (invoiceId || paymentIntentId || setupIntentId) {
      void verifyAttempt({
        invoiceId: invoiceId || undefined,
        paymentIntentId: paymentIntentId || undefined,
        paymentMethodType: paymentMethodType || undefined,
        setupIntentId: setupIntentId || undefined,
      });
    }
  }, [
    verifyAttempt,
    invoiceId,
    paymentIntentId,
    paymentMethodType,
    setupIntentId,
  ]);

  return null;
};
